import { SharedContent } from './shared-content';

export const DocumentUploadContent = {
  loading: `Loading draft...`,
  progressLabelDivorce: SharedContent.progressLabelDivorce,
  pageTitle1: `Upload the document related to `,
  pageTitle2: ` passing`,
  pageDescription1: `We were unable to verify `,
  pageDescription2: ` passing by checking our systems, so we’ll need you to upload a digital copy of the death certificate.`,
  iraExecutor: {
    pageTitle1: `Upload `,
    pageTitle2: ` documents`,
    pageDescription1: `We need digital copies of the following:`,
    pageDescription2: `Death certificate`,
    pageDescription3: `Letters of testamentary, letters of administration, or short certificate (dated within 1 year)`,
    accordions: [
      {
        title: `How do I obtain the required documents?`,
        text: `Death certificates can generally be requested through the funeral home or from the vital records office. <br/><br/> Letters of testamentary, letters of administration, or short certificate can be provided by the decedent's local courthouse.`,
      },
      {
        title: `How do I get a digital copy of the death certificate?`,
        text: `You can take a picture of the physical copy with your smart phone and upload it here.`,
      },
    ],
  },
  continueButton: `Upload & continue`,
  internalContinueText: `Document upload is optional for crew`,
  accordionsNew: [
    {
      title: `How do I obtain a death certificate?`,
      text: `The death certificate is usually prepared by a medical examiner and can be requested through the funeral home or directly from the vital records office.`,
    },
    {
      title: `How do I create a digital copy of the death certificate?`,
      text: `If you don’t have a digital copy of the death certificate, you can try the following: take a picture of the physical copy with your phone, email it to yourself, save it to your computer, and then upload it here.`,
    },
  ],
  attachedFile: 'file(s) attached',
  fileSizeLimit: 'of 25 MB',
  documentShareTermsLink: {
    label: 'Document share',
    linkText: 'Terms of Use',
    overlayAriaLabel: 'Accept the Document Share terms before uploading',
  },
  errorMessages: {
    fileTooLarge: 'The file you want to upload is too large. Please reduce its size and try again.',
    invalidFileType:
      'The file you want to upload is an unacceptable file type. Please upload either an image file or a PDF file instead.',
    fileNotSaved: 'The file you want to upload failed to save. Please try again.',
    missingFile: 'Please upload the required document(s) to continue.',
    totalFileSizeLength:
      'The total file size exceeds the maximum limit of 25 MB. Please reduce the size of your files and try again.',
  },
  fileUpload: {
    browse: 'browse files',
    description: 'Total upload size: 25MB',
    fileTypes: 'Supporting file type: PDF, JPEG, PNG',
    title: 'Drag and drop file here or',
    uploadFileAriaLabel: 'Drag and drop file here or browse files',
  },
  divorceFlow: {
    nextSection: {
      title: `Next up:`,
      text: `account selection`,
    },
    header: `Now, let’s add your documents`,
    dropdown: {
      header: `Required documents`,
      subheading1: `You will need to upload a stamped or signed court-certified document that stipulates the IRA assets to be transferred. Acceptable documents include:`,
      lists1: [
        `Divorce decree and property settlement or agreement that is part of a divorce decree`,
        `Domestic relations order`,
        `Separation order`,
        `Qualified domestic relations order (QDRO)`,
      ],
      subheading2: `The uploaded documents must:`,
      lists2: [
        `Specify that IRA assets are to be transferred.`,
        `List the name of the Vanguard IRA owner and the name of the former spouse that will be receiving the transfer.`,
        `List the amount to be transferred, expressed in dollars, a percentage, or number of shares.`,
      ],
      note: {
        title: `Note:`,
        text: `The documents uploaded must meet the above requirements for Vanguard to process this request.`,
      },
    },
    maxFileSize: `Maximum file size: 25 MB`,
    internalContinueButton: `Continue`,
    errorMessagesDivorceFlow: {
      invalidFileType:
        'The file you selected is not supported. You must upload a PDF, JPEG, or PNG.',
      fileNotSaved: 'The file you want to upload failed to save. Please try again.',
      missingFile: 'You must upload one of the required divorce documents to continue.',
    },
  },
  taxUploadOptions: {
    title: 'Didn’t upload a document? Let us know why',
    option1: 'You plan on mailing in the form after completing this process',
    option2: 'Another beneficiary on the account has submitted the required form',
    option3: 'You’ve confirmed you don’t need an inheritance form',
  },
  taxUploadFaq: {
    title: 'Prefer to mail in your form?',
    subtitle1: 'Here’s where to mail in your form:',
    vanguard: 'Vanguard',
    address1Line1: 'P.O. Box 982901',
    address1Line2: 'El Paso, TX 79998-2901',
    subtitle2: 'For registered or certified mail, or overnight delivery:',
    address2Line1: '5951 Luckett Court, Suite A1',
    address2Line2: 'El Paso, TX 79932-1882',
  },
  itwUpload: {
    pageTitle: 'We may need an Inheritance Tax Waiver for ',
    subtext1: 'Because ',
    subtext2:
      ' was a Pennsylvania resident, we may need an Inheritance Tax Waiver (ITW). You should have received your ITW  after submitting your form ',
    subtext3: ' to the state.',
    link1Href: 'https://www.pa.gov/agencies/revenue',
    link1Text: 'More information (Pennsylvania Department of Revenue)',
    link2Href:
      'https://www.pa.gov/content/dam/copapwp-pagov/en/revenue/documents/formsandpublications/formsforindividuals/inheritancetax/documents/rev-516.pdf',
    link2Text: 'REV-516',
    warningModal: {
      title: 'Important',
      description:
        'We won’t be able to complete your request until we receive your Inheritance Tax Waiver (ITW). You’ll receive your ITW after you submit your ',
      description2: ' to the state. Your request will be pending until we receive your ITW.',
      closeButton: 'I understand',
    },
  },
  l8Upload: {
    pageTitle: 'We may need an L-8 form',
    subtext1: 'Because ',
    subtext2:
      ' was a New Jersey resident, you may need to submit a notarized L-8 form (or another inheritance tax form) in order for us to process this inheritance. If you’ve already completed your inheritance form, please upload it here.',
    subtitle: 'Not sure if you need an L-8?',
    subtext3: 'Learn more about inheritance tax filing requirements on the ',
    linkHref:
      'https://www.nj.gov/treasury/taxation/inheritance-estate/inheritance-taxfilerequirements.shtml',
    linkText: 'New Jersey’s Division of Taxation website',
    warningModal: {
      title: 'Important',
      description:
        'We won’t be able to complete your request until we receive your L8 form. Your request will be pending until we receive the required paperwork.',
      closeButton: 'I understand',
    },
  },
  transferAnotherAccountButton: 'Transfer another account',
  l8ItwErrorBannerText: 'Please either submit a document or select a checkbox to continue.',
  l8ItwUploadBannerText:
    'Thanks for uploading your form. We’ll reach out if we have any questions or are unable to verify your form.',
};
